import { LucideIcon, Inbox } from 'lucide-react';
import React from 'react';

interface EmptyStateProps {
    icon?: LucideIcon | undefined;
    title?: string | undefined;
    message?: string | undefined;
    action?: React.ReactNode | undefined;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    icon: Icon = Inbox,
    title = 'No data found',
    message,
    action,
}) => {
    return (
        <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-4">
                <Icon size={24} className="text-slate-400" />
            </div>
            <h3 className="text-sm font-medium text-slate-900 mb-1">{title}</h3>
            {message && (
                <p className="text-sm text-slate-500 max-w-sm">{message}</p>
            )}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
};

export default EmptyState;
